module.exports = __webpack_public_path__ + "img/sp-house-support.png";